/*
 *	Service to interact with the backend API for fetching and updating tax rates.
 *	Provides functions to get tax rates, create new tax rates, update existing tax rates, and delete tax rates.
 */

// -------------
// API TOOL (OK)
// -------------

// Import necessary types
import { TaxRateData } from '../types/types';
import { apiResource } from '../../../common/services/apiClient';
import { getApiBaseUrl } from 'common/services/apiBaseUrl';

export const taxRatesApi = apiResource<TaxRateData>('tax-rates');

// -------------------------
// LEGACY (TODO : to remove)
// -------------------------

// Base URL of the API
// const API_URL = 'http://localhost:8000/api/v2';
const apiBaseUrl = getApiBaseUrl();
export const API_URL = apiBaseUrl + '/v2';

import { apiFetch } from 'common/services/apiFetch';

// Fetch all tax rates
export const getTaxRates = async (token: string): Promise<TaxRateData[]> => {
	const res = await apiFetch(`${API_URL}/tax-rates`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	});
	if (!res.ok) {
		throw new Error('Failed to fetch tax rates');
	}
	return res.json();
};

// Fetch a single tax rate by ID
export const getTaxRateById = async (
	id: number,
	token: string
): Promise<TaxRateData> => {
	const res = await apiFetch(`${API_URL}/tax-rates/${id}`, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	});
	if (!res.ok) {
		throw new Error('Failed to fetch tax rate');
	}
	return res.json();
};

// Edit an existing tax rate
export const updateTaxRate = async (
	id: number,
	taxRate: Partial<TaxRateData>,
	token: string
): Promise<TaxRateData> => {
	const res = await apiFetch(`${API_URL}/tax-rates/${id}`, {
		method: 'PATCH',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(taxRate),
	});
	if (!res.ok) {
		throw new Error('Failed to update tax rate');
	}
	return res.json();
};

// Create a new tax rate
export const createTaxRate = async (
	taxRate: Partial<TaxRateData>,
	token: string
): Promise<TaxRateData> => {
	const res = await apiFetch(`${API_URL}/tax-rates`, {
		method: 'POST',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(taxRate),
	});
	if (!res.ok) {
		throw new Error('Failed to create tax rate');
	}
	return res.json();
};

// Delete a tax rate by ID
export const deleteTaxRate = async (
	id: number,
	token: string
): Promise<void> => {
	const res = await apiFetch(`${API_URL}/tax-rates/${id}`, {
		method: 'DELETE',
		headers: {
			Authorization: `Bearer ${token}`,
			'Content-Type': 'application/json',
		},
	});
	if (!res.ok) {
		throw new Error('Failed to delete address');
	}
};
